window.addEventListener("DOMContentLoaded", () => {
	let notaires = document.querySelectorAll(".les_notaires .notaire");
	let modale = document.querySelector(".notaire_modale");
	if (notaires && modale) {
		let close_modale = modale.querySelector(".close_presentation");
		let modale_name = modale.querySelector(".name");
		let modale_texte = modale.querySelector(".texte");
		let modale_lien = modale.querySelector(".linkedin");
		notaires.forEach((el) => {
			el.addEventListener("click", () => {
				modale_name.innerHTML = el.dataset.name;
				modale_texte.innerHTML = el.dataset.presentation;
				if (el.dataset.linkedin.length > 10) {
					modale_lien.innerHTML = el.dataset.linkedin;
					modale_lien.style.display = "block";
				} else {
					modale_lien.innerHTML = "";
					modale_lien.style.display = "none";
				}

				modale.classList.add("visible");
			});
		});
		close_modale.addEventListener("click", () => {
			modale.classList.add("masked");
			setTimeout(() => {
				modale.classList.remove("masked");
				modale.classList.remove("visible");
			}, 600);
		});
	}
});
